const processRevStreamItems = function(revs) {
  const items = revs.map(item => {
    try {
      if (item.cycle.relatePhoto.metadata.orientation) {
        item.height = 380
        item.width = 300
        item.orientation = 'landscape'
      }
    } catch (e) {
      item.height = 380
      item.width = 300
      item.orientation = 'landscape'
    }

    return item
  })

  return items
}

export default processRevStreamItems
